module.exports = __webpack_public_path__ + "img/placeholder.7bea79df.jpg";